module.exports = function() {

    /**
     * Controllers
     */
    var MaintenanceCalendarController = new (require('./MaintenanceCalendarController'))();

	MaintenanceCalendarController.render();
}();